import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  dropdownItems = [
    'Fistulas',
    'Anal Fissures',
    'Hemorrhoids',
    'Anorectal Abscesses',
  ];
  @Output() openModal: EventEmitter<void> = new EventEmitter();
  mascodClicked:boolean=false;
  constructor() { }

  ngOnInit(): void {
  }

  openLoginModal(){
    this.openModal.emit();
  }

  triggerWobble() {
    this.mascodClicked = false; 
    setTimeout(() => {
      this.mascodClicked = true;
    }, 10); 
  }
  
}
